// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/photo.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/photo'

import { Icon, type IconComponentProps } from '../icon'

export const PhotoIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
